import React from "react";
import FetchHelper from "./lib/fetchHelper.js";
import { INBOX_READ_EVENT } from "./MemberInboxComponent";
import { ReactRenderer } from "./lib/ReactRenderer";
/**
 * The link to the inbox with the number of unread messages, in two shapes: an icon button in the
 * wide top bar and the Indbakke tab of the bottom bar. Each instance fetches the count itself;
 * only the first one on the page (the top bar's) re-registers the push subscription, see index.ts.
 */
export class InboxBadgeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { count: 0 };
        this.refresh = this.refresh.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.onInboxRead = this.onInboxRead.bind(this);
    }
    componentDidMount() {
        this.refresh();
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        window.addEventListener(INBOX_READ_EVENT, this.onInboxRead);
    }
    componentWillUnmount() {
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
        window.removeEventListener(INBOX_READ_EVENT, this.onInboxRead);
    }
    onVisibilityChange() {
        if (document.visibilityState === "visible")
            this.refresh();
    }
    onInboxRead(event) {
        var _a;
        this.setState({ count: (_a = event.detail) !== null && _a !== void 0 ? _a : 0 });
    }
    refresh() {
        FetchHelper.get("/bpapi/memberinbox/unreadcount")
            .then((result) => { var _a; return this.setState({ count: (_a = result.count) !== null && _a !== void 0 ? _a : 0 }); })
            .catch(() => undefined);
    }
    render() {
        const { count } = this.state;
        const { tab, current } = this.props;
        const label = count > 0 ? `Indbakke, ${count} ulæste beskeder` : "Indbakke";
        const badge = count > 0 &&
            React.createElement("span", { className: "bi-count", "aria-hidden": "true" }, count > 99 ? "99+" : count);
        if (tab) {
            return (React.createElement("a", { href: this.props.href, className: `bi-tab${current ? " active" : ""}`, "aria-label": label, "aria-current": current ? "page" : undefined },
                React.createElement("i", { className: "fa-solid fa-inbox", "aria-hidden": "true" }),
                React.createElement("span", null, "Indbakke"),
                badge));
        }
        return (React.createElement("a", { href: this.props.href, className: "bi-icon-btn", "aria-label": label, title: label },
            React.createElement("i", { className: "fa-solid fa-inbox", "aria-hidden": "true" }),
            badge));
    }
}
ReactRenderer.render("inboxbadgecomponent", (elem) => React.createElement(InboxBadgeComponent, { href: elem.dataset.href || "/min-side/indbakke", tab: elem.dataset.variant === "tab", current: elem.dataset.current === "true" }));
